import NOTIFICATION_TYPES from './types';

type variant = 'success' | 'warning' | 'info' | 'error';

function add(variant: variant, message: string) {
	return {
		type: NOTIFICATION_TYPES.ADD,
		payload: { variant, message },
	};
}

function clean() {
	return {
		type: NOTIFICATION_TYPES.CLEAN,
	};
}

const notificationActions = {
	add,
	clean,
};

export default notificationActions;
